"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _lib = require("../../lib");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ArcSlider(props) {
  var range = props.range,
    min = props.min,
    max = props.max,
    disabled = props.disabled,
    defaultValue = props.defaultValue,
    included = props.included,
    dots = props.dots,
    tooltipVisible = props.tooltipVisible,
    value = props.value,
    onChange = props.onChange;
  return /*#__PURE__*/_react["default"].createElement(_lib.Slider, {
    range: range,
    defaultValue: range ? [min ? min : 1, max ? max : 10] : defaultValue,
    onChange: onChange,
    min: min,
    tooltipVisible: tooltipVisible,
    max: max,
    value: value,
    dots: dots,
    included: included,
    disabled: disabled
  });
}
var _default = ArcSlider;
exports["default"] = _default;